var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _c(
          "router-link",
          {
            attrs: {
              to: {
                name: "bpmn",
                params: {
                  processId: _vm.value.id,
                },
              },
            },
          },
          [_c("span", [_vm._v("EDIT")])]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }